import { gql } from '@apollo/client';

const SalesGptFragment = gql`
  fragment SalesGptFragment on SearchResultInterface {
    category
    ... on WarRoomPostCommentSearchResult {
      record {
        id
        rawText
        post {
          slug
        }
        author {
          ... on Anonymous {
            username
            warRoomAvatarUrl
          }
          ... on Public {
            firstname
            lastname
            avatarUrl
          }
        }
      }
    }
    ... on AcademyArticleSearchResult {
      article {
        id
        title
        slug
        author {
          name
          avatar {
            url
          }
        }
      }
    }
  }
`;

export default SalesGptFragment;
